import * as core from '../../../../../../../core'
import * as jiraStatus from '../jira-status'

export const RESOURCE = {
  payload: {
    description: 'The Jira issue has not yet been started',
    enumId: core.dms.models.Enum.Id.from({
      partialId: jiraStatus.RESOURCE.payload.partialId,
    }),
    id: 'To Do',
    name: 'To Do',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
